import { render, staticRenderFns } from "./LayoutWorkflow.vue?vue&type=template&id=0fd2e1c4&scoped=true&"
import script from "./LayoutWorkflow.vue?vue&type=script&lang=js&"
export * from "./LayoutWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./LayoutWorkflow.vue?vue&type=style&index=0&id=0fd2e1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd2e1c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VAppBar,VFlex,VLayout,VMain,VNavigationDrawer})
